// extracted by mini-css-extract-plugin
export default {"scoreRing":"styles_scoreRing__0pDwG","background":"styles_background__+fqxF","progress":"styles_progress__LCVEg","score":"styles_score__FpQXN"};